import ApplicationController from 'javascript/controllers/application_controller';

export default class extends ApplicationController {
  connect() {
    const isTouchDevice = window.matchMedia?.('(pointer: coarse)')?.matches;

    if (!isTouchDevice) {
      this.element.classList.add('hover-enabled');
    }
  }
}
